import { DateInputFormik } from '@strata/react-date-time';
import { InlineMessage } from '@strata/react-inline-message';
import dayjs from 'dayjs';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

import {
    createDisableDateMatchers,
    getOverlappingSegmentRules,
} from 'pages/routeManagement/backstopPharmacies/backstopPharmacyOverlapSupport';

const SEGMENT_SEGMENT_WARNING =
    'This segment already has an assignment for this product. Active dates must not overlap.';

const UNIVERSAL_UNIVERSAL_WARNING =
    'A universal assignment already exists for this product. Active dates must not overlap.';

export const BackstopPharmacyDateFields = ({
    siblingBackstops = undefined,
    currentBackstopPharmacyId = undefined,
    isUsed = false,
    isUniversal = false,
}) => {
    const formik = useFormikContext();
    const overlappingSiblingRules = getOverlappingSegmentRules(
        siblingBackstops,
        formik.values,
        currentBackstopPharmacyId,
    );
    const disabledDateMatchers = createDisableDateMatchers(overlappingSiblingRules);
    const dayPickerProps =
        disabledDateMatchers.length > 0 ? { disabled: disabledDateMatchers } : undefined;

    return (
        <>
            <DateInputFormik
                id="backstopStartDate"
                label="Start Date"
                required
                minDate={dayjs().startOf('day').toDate()}
                disabled={
                    isUsed || dayjs(formik.initialValues.backstopStartDate).isBefore(dayjs(), 'day')
                }
                dayPickerProps={dayPickerProps}
            />
            {overlappingSiblingRules.length > 0 && (
                <div className="margin__bottom--medium">
                    <InlineMessage
                        intent={InlineMessage.Intent.WARNING}
                        wrapText
                        label={isUniversal ? UNIVERSAL_UNIVERSAL_WARNING : SEGMENT_SEGMENT_WARNING}
                    />
                </div>
            )}
            <DateInputFormik
                id="backstopEndDate"
                label="End Date"
                minDate={dayjs(formik.values.backstopStartDate)
                    .startOf('day')
                    .add(1, 'day')
                    .toDate()}
                dayPickerProps={dayPickerProps}
            />
        </>
    );
};
BackstopPharmacyDateFields.propTypes = {
    siblingBackstops: PropTypes.arrayOf(
        PropTypes.shape({
            backstop_pharmacy_id: PropTypes.string,
            product_service_oid: PropTypes.string,
            is_brand: PropTypes.bool,
            benefit: PropTypes.string,
            place_of_service: PropTypes.string,
            backstop_start_date: PropTypes.string,
            backstop_end_date: PropTypes.string,
        }),
    ),
    currentBackstopPharmacyId: PropTypes.string,
    isUsed: PropTypes.bool,
    isUniversal: PropTypes.bool,
};
